export const customersEn = {
    title: 'Customers',
    list: 'Customer list',
    detail: 'Customer detail',
    create: 'Create customer',
    delete: 'Delete customer',
    deleteConfirm: 'Are you sure you want to delete this customer?',
    columns: {
        id: 'ID',
        customerId: 'Customer ID',
        name: 'Name',
        ordersCount: 'Orders',
        actions: 'Actions'
    },
    model: {
        customerId: 'Customer ID',
        name: 'Name'
    },
    orders: {
        title: 'Associated orders',
        orderId: 'Order ID',
        name: 'Name',
        state: 'State',
        requestedDeliveryDate: 'Requested delivery date',
        createdAt: 'Created at'
    },
    errors: {
        fetchFailed: 'Failed to load customers',
        createFailed: 'Failed to create customer',
        updateFailed: 'Failed to update customer',
        deleteFailed: 'Failed to delete customer'
    },
    success: {
        created: 'Customer created successfully',
        deleted: 'Customer deleted successfully',
        updated: 'Customer updated successfully'
    },
    table: {
        actions: {
            deleteTitle: 'Delete customer',
            deleteContent: 'Are you sure you want to delete the customer ? This action is final.'
        }
    }
}
